module.exports = __webpack_public_path__ + "img/img_29 - 副本.2f8afb3e.png";